import { render, staticRenderFns } from "./FlyoutMenuItem.vue?vue&type=template&id=7b04d580"
import script from "./FlyoutMenuItem.vue?vue&type=script&lang=js"
export * from "./FlyoutMenuItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports